module.exports = __webpack_public_path__ + "img/comment-canvas-card.8c8b677a.svg";